import { render, staticRenderFns } from "./register.vue?vue&type=template&id=0f628a66&"
import script from "./register.ts?vue&type=script&lang=ts&"
export * from "./register.ts?vue&type=script&lang=ts&"
import style0 from "./register.vue?vue&type=style&index=0&id=0f628a66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports